<template>
  <div class="screen-booking">
    <div class="popup-aside-plain">
      <div class="popup-takeResa">
        <div style="text-align:center">{{ getAllInfos.restoName }}</div>
        <div style="font-weight:100; font-size:14px">
          <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
          <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
        </div>
      </div>
      <div class="change-container" v-loading="loading">
        <!-- START Screen -->
        <div class="change-content" v-if="getCurrentResa !== undefined && getStep === 'START'">
          <div class="change-wylike">Souhaitez vous<br> modifier ou annuler<br> la réservation suivante :</div>
          <div class="change-infos">
            <div>{{ getCurrentResa.dateResa.labelDay }} {{ getCurrentResa.dateResa.label }} {{
              getCurrentResa.dateResa.labelMonth }} {{ getCurrentResa.dateResa.year }}</div>
            <div>à {{ getCurrentResa.hour }}</div>
            <div>pour {{ getCurrentResa.nbCouvert }} couverts</div>
          </div>
          <el-row v-if="getIfCancelable" class="black-inputs change-btns">
            <el-col :span="9" :offset="2">
              <el-button class="red" type="primary" @click="cancelResa">Annuler</el-button>
            </el-col>
            <el-col :span="9" :offset="2">
              <el-button type="primary" @click="modifyResaCall">Modifier</el-button>
            </el-col>
          </el-row>
          <el-row v-else-if="getLimitHours" class="black-inputs change-btns">
            Vous ne pouvez modifier ou annuler la réservation,<br>
            {{ getLimitHours.hours }}H avant le début de celle-ci.
          </el-row>
        </div>

        <!-- NOTHING Screen -->
        <div class="change-content" v-if="getStep === 'NOTHING'">
          La réservation ne semble plus d'actualité,<br>
          nous vous conseillons de contacter directement le restaurant<br><br>
          <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
          <div style="text-align:center"><a :href="'mailto:' + getAllInfos.restoMail">{{ getAllInfos.restoMail }}</a>
          </div>
          <br>
          Bonne journée de la part de Resa Ninja
        </div>

        <!-- CANCEL_DONE Screen -->
        <div class="change-content" v-if="getStep === 'CANCEL_DONE'">
          <div>
            Nous avons bien pris en compte votre demande d'annulation,<br>
            l'information a été transmise au restaurateur.<br>
            Bonne journée de la part de Resa Ninja
          </div>
        </div>

        <!-- CANCEL_DONE Screen -->
        <div class="change-content" v-if="getStep === 'MODIFY_DONE'">
          <div>
            Nous avons bien pris en compte votre demande de modification,<br>
            l'information a été soumise à validation au restaurateur.<br>
            Bonne journée de la part de Resa Ninja
          </div>
        </div>

        <!-- MODIFY screen -->
        <div class="change-content" v-if="getStep === 'MODIFY'">
          <el-row :class="'black-inputs'">
            <el-col :span="18" :offset="3">
              <el-form ref="formModify.data" :model="formModify.data" label-width="120px">
                <el-form-item>
                  <calendar-nav :checkVisibility="true" />
                </el-form-item>
                <el-form-item v-if="getCurrentResa.type !== 'prepaiement'">
                  <el-input-number class="text-centered" size="medium"
                    :min="this.getSelectedMainServiceData.nbMinByResa"
                    :max="this.getSelectedMainServiceData.nbMaxByResa" v-model="formModify.data.nbCouvert"
                    @change="nbCouvUpdate"></el-input-number>
                </el-form-item>
                <el-form-item v-loading="loadingHours">
                  <div class="popup-takeResa-dayClosed" v-if="getServicesHours === null && !complet">Fermé</div>
                  <div class="popup-takeResa-dayClosed" v-if="complet">Complet</div>
                  <div class="popup-takeResa-dayClosed" v-if="allServiceIsLock && !limitInterval">Service fermé</div>
                  <div class="popup-takeResa-dayClosed" v-if="allServiceIsLock">Fermeture exceptionnelle</div>
                  <el-select v-if="getServicesHours !== null && !complet && !allServiceIsLock" class="text-centered"
                    v-model="formModify.data.date2" value-key="id" placeholder="Choisissez une heure">
                    <el-option-group v-for="ms in getServicesHoursData" :key="ms.label" :label="ms.label"
                      v-if="ms.tab.length > 0">
                      <el-option v-for="h in ms.tab" :key="h.id" :label="h.hour" :value="h">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="formModify.data.commentResa" :autosize="{ minRows: 3 }" type="textarea"
                    placeholder="Ajouter un commentaire"></el-input>
                </el-form-item>
                <div v-loading="loadingTakeResa">
                  <el-form-item>
                    <el-row :gutter="20">
                      <el-col :span="24">
                        <el-button v-if="!loadingTakeResa && !complet && !allServiceIsLock && formModify.data.date2"
                          :disabled="btnModifyDisabled" type="primary"
                          @click="validModification('formModify.data')">Modifier</el-button>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </div>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// ------------------------------------------------------------------------------------ Imports
import uuidv4 from 'uuid/v4'
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import 'whatwg-fetch'
import { ERequestType, fetchGetHelper, fetchPostHelper, fetchPutHelper } from '../tools/fetch'
import * as resaState from './../store/types/resa-state'
import { sendResaCancelRestaurateur, sendResaCancelledMessage, sendResaModifyMail, sendResaModifyRestaurateur } from './../tools/messageSender'
import { dateToTimeStamp, formatTimeH, parseTime } from './../tools/timeTool'
import CalendarNav from './calendar/CalendarNavPicker'

export default {
  name: 'Change',
  // -------------------------------------------------------------------------------- Components
  components: { CalendarNav },
  // -------------------------------------------------------------------------------- Datas
  data() {
    return {
      currentResa: undefined,
      step: 'START',
      currentClient: undefined,
      loading: false,
      formModify: {
        data: {
          nbCouvert: 2,
          date1: new Date(),
          date2: '',
          room: '',
          tids: {},
          commentResa: ''
        },
        show: false
      },
      complet: false,
      allServiceIsLock: false,
      tabHours: {},
      loadingHours: false,
      loadingTakeResa: false,
      btnModifyDisabled: false,
      currentNbCouv: 0,
      limitAnnulation: '00:00'
    }
  },
  computed: {
    // ------------------------------------------------------------------------------ Getters
    ...mapGetters({
      getAllInfos: 'infos/getAllInfos',
      getSelectedMainServiceData: 'newServices/getSelectedMainServiceData',
      getSelectedDay: 'calendar/getSelectedDay',
      getDaysIsClosed: 'newServices/getDaysIsClosed',
      getDaysIsInvisible: 'newServices/getDaysIsInvisible',
      getMainServiceDataByServiceAndDay: 'newServices/getMainServiceDataByServiceAndDay'
    }),
    getCurrentResa: function () {
      return this.currentResa
    },
    getStep: function () {
      return this.step
    },
    getServicesHoursData: function () {
      return this.tabHours
    },
    getCouvSelected: function () {
      if (this.currentNbCouv === 0) return 2
      return parseInt(this.currentNbCouv)
    },
    getCashLimitAnnulation: async function () {
      let ts = dateToTimeStamp(this.getCurrentResa.dateResa.day, this.getCurrentResa.dateResa.month - 1, this.getCurrentResa.dateResa.year)
      let service = this.getCurrentResa.ms
      return this.checkExistCashDays({
        restoid: this.$router.currentRoute.params.id,
        ts: ts,
        service: service
      }).then(res => {
        if (res && res !== '') {
          return res.limitHour
        } else if (this.getSelectedMainServiceData && this.getSelectedMainServiceData.cashOn) {
          return this.getSelectedMainServiceData.cashLimitHour
        }
        return '00:00'
      }).catch(() => {
        return '00:00'
      })
    },
    getLimitHours: function () {
      return parseTime(this.limitAnnulation)
    },
    getIfCancelable: function () {
      let limit = null
      // get limit of classical service
      if (this.getSelectedMainServiceData && this.getSelectedMainServiceData.limitAnnulation && this.getSelectedMainServiceData.limitAnnulation !== '00:00') {
        limit = this.getSelectedMainServiceData.limitAnnulation
        // get limit of classical service if have a caution
      } else if (this.getSelectedMainServiceData && this.getSelectedMainServiceData.cashType === 'caution' && this.getSelectedMainServiceData.cashLimitHour !== '00:00') {
        limit = this.getSelectedMainServiceData.cashLimitHour
      }
      // aucune limit est définie
      if (!limit) {
        // on verifie les cashdays
        if (this.getCurrentResa.type === 'caution') {
          this.getCashLimitAnnulation.then(val => {
            this.limitAnnulation = val
            return this.checklimit(val)
          })
        } else {
          return true
        }
      } else {
        this.limitAnnulation = limit
        return this.checklimit(limit)
      }
    },
    async getServicesHours(e) {
      if (this.getSelectedDay !== '' && !this.getDaysIsClosed(this.getSelectedDay.weekday, true) && !this.getDaysIsInvisible(this.getSelectedDay.weekday) && this.currentNbCouv) {
        this.loadingHours = true
        this.complet = false
        let tabHSResult = null
        let dateTemp = this.getSelectedDay.date
        const result = await this.findFirstOpenServiceHours({ day: this.getSelectedDay, keepCurrent: false, passed: false, checkLock: true, checkVisibility: true }).then(async (tabHS) => {
          // get first disponnible hour
          // check if service is lock
          if (Object.entries(tabHS).length > 0) {
            // let count = 0
            let checkInterval = false
            // curent each service get tab hour
            let tempTabHS = JSON.parse(JSON.stringify(tabHS))
            // last length for match capacityinterval tab id
            let lastLenght = 0
            for (let i = 0; i < Object.entries(tabHS).length; i++) {
              let s = Object.entries(tabHS)[i]
              let currentServiceDatas = this.getMainServiceDataByServiceAndDay(s[0], this.getSelectedDay.labelDay)
              // if lock delete service
              if (s[1].lock) {
                Vue.delete(tempTabHS, s[0])
              } else if (currentServiceDatas.capacityIntervalTab && currentServiceDatas.capacityIntervalTab.length > 0) {
                checkInterval = true
                // if capacity par tranche horraire exist
                let idToRemove = []
                // get occupation by hour
                let request = {
                  uid: this.$router.currentRoute.params.id,
                  ts: dateToTimeStamp(this.getSelectedDay.day, this.getSelectedDay.month - 1, this.getSelectedDay.year)
                }
                await this.loadNbCouvByHour(request).then(res => {
                  s[1].tab.forEach(h => {
                    // real id of tab
                    let checkid = parseInt(h.id) - lastLenght
                    // get places avaibles
                    if (currentServiceDatas.capacityIntervalTab[checkid] && currentServiceDatas.capacityIntervalTab[checkid].capacity > 0) {
                      let couvTaked = 0
                      if (res.data[h.hour]) couvTaked = res.data[h.hour]
                      let couvCapacity = currentServiceDatas.capacityIntervalTab[checkid].capacity
                      let couvAvaible = couvCapacity - couvTaked
                      // save id to remove if complet for this hour
                      if (couvAvaible - parseInt(this.formModify.data.nbCouvert) < 0) {
                        idToRemove.push(h.hour)
                      }
                    } else if (currentServiceDatas.capacityIntervalTab[checkid] && currentServiceDatas.capacityIntervalTab[checkid].capacity < 0) {
                      idToRemove.push(h.hour)
                    }
                  })
                  lastLenght += s[1].tab.length
                })
                if (idToRemove.length >= Object.entries(tempTabHS).length) this.complet = true
                // remove id to remove
                idToRemove.forEach(hour => {
                  tempTabHS[s[0]].tab = tempTabHS[s[0]].tab.filter((h, index) => h.hour !== hour)
                })
                // remopve service if no hour avaible
                if (tempTabHS[s[0]].tab.length === 0) Vue.delete(tempTabHS, s[0])
              }
            }
            tabHSResult = Object.assign({}, tempTabHS)
            // check if current selected hour keep existing
            if (this.getSelectedDay.date !== dateTemp) {
              this.formModify.data.data2 = ''
            } else {
              let found = false
              Object.entries(tabHSResult).forEach(([index, hs]) => {
                hs.tab.forEach(hTest => {
                  if (hTest.hour === this.getCurrentResa.hour) found = true
                })
              })
              // set hour resa if existing or not
              if (!found) this.formModify.data.date2 = ''
              else this.formModify.data.date2 = this.getCurrentResa.hour

              if (Object.entries(tabHSResult).length === 0) {
                this.loadingHours = false
                this.allServiceIsLock = true
                if (checkInterval) this.limitInterval = true
                return null
              } else {
                this.allServiceIsLock = false
                this.limitInterval = false
              }
            }
          }
          if (this.getSelectedDay.date !== dateTemp) {
            this.loadingHours = false
            return null
          } else {
            return this.getCurrentCapacity({ selectDay: this.getSelectedDay, tabHour: tabHSResult, nbCouv: parseInt(this.formModify.data.nbCouvert) }).then((tab) => {
              if (Object.entries(tab).length > 0) {
                if (this.formModify.data.date2 === '') this.formModify.data.date2 = tab[Object.keys(tab)[0]].tab[0]
                else {
                  let found = false
                  Object.entries(tab).forEach(([index, hs]) => {
                    hs.tab.forEach(hTest => {
                      if (hTest.hour === this.formModify.data.date2.hour) {
                        found = true
                        this.formModify.data.date2 = hTest
                      }
                    })
                  })
                  if (!found) this.formModify.data.date2 = tab[Object.keys(tab)[0]].tab[0]
                }
                this.tabHours = tab
                this.complet = false
                this.loadingHours = false
                return tab
              } else {
                this.loadingHours = false
                this.complet = true
                return null
              }
            })
          }
          // check if service is complet
        })
        return result
      } else {
        this.loadingHours = false
        this.complet = true
        return null
      }
    }
  },
  methods: {
    // ----------------------------------------------------------------------------- Methods and Actions
    ...mapActions({
      getCurrentCapacity: 'newServices/getCurrentCapacity',
      findFirstOpenServiceHours: 'newServices/findFirstOpenServiceHours',
      checkClientByCidExisting: 'newClients/checkClientByCidExisting',
      loadNbCouvByHour: 'newReservations/loadNbCouvByHour',
      checkExistCashDays: 'cash/checkExistCashDays'
    }),
    ...mapMutations({
      setSelectedResa: 'newReservations/setSelectedResa',
      setSelectedDay: 'calendar/setSelectedDay',
      setSelectedService: 'newServices/setSelectedService'
    }),
    nbCouvUpdate: function (val) {
      this.currentNbCouv = val
    },
    checklimit: function (limit) {
      // get today ts
      let today = new Date()
      let todayTs = today.getTime()

      let limitO = parseTime(limit)
      let resaHour = parseTime(this.getCurrentResa.hour)
      let dateResa = new Date(this.getCurrentResa.dateResa.date)
      dateResa.setMinutes(resaHour.minutes - limitO.minutes)
      dateResa.setHours(resaHour.hours - limitO.hours)
      let dateResaTs = dateResa.getTime()
      return dateResaTs > todayTs
    },
    /**
     * cancel Resa in db and send mail to client and restorateur
     */
    cancelResa: function () {
      this.loading = true
      let resaToCancel = Object.assign({}, this.currentResa)
      resaToCancel.state = resaState.CANCELLED
      resaToCancel.modifyBy = 'CLIENT'
      fetchPutHelper(ERequestType.RESAS.UPDATE, resaToCancel).then((updatedCR) => {
        this.loading = false
        this.step = 'CANCEL_DONE'
        // send mail
        let hourFormatted = formatTimeH(parseTime(this.currentResa.hour))
        // send mail to client
        sendResaCancelledMessage({
          clientName: `${this.currentClient.name} ${this.currentClient.prenom}`,
          clientEmail: this.currentClient.email,
          restoName: this.getAllInfos.restoName,
          restoEmail: this.getAllInfos.restoMail,
          dateResa: `${this.currentResa.dateResa.labelDay} ${this.currentResa.dateResa.day.toString()} ${this.currentResa.dateResa.labelMonth} ${this.currentResa.dateResa.year.toString()}`,
          hourResa: hourFormatted,
          message: 'Vous avez annulé la réservation',
          nbCouverts: this.currentResa.nbCouvert,
          adresse: this.getAllInfos.restoAdresse,
          tel: this.getAllInfos.restoTel,
          sendSms: !!this.getAllInfos.clientSmsSended,
          clientTel: this.currentClient.tel,
          clientTelPreFix: this.currentClient.telPreFix,
          restoid: this.getAllInfos.restoid
        })
        // send mail to restaurateur
        sendResaCancelRestaurateur({
          clientName: `${this.currentClient.name} ${this.currentClient.prenom}`,
          clientEmail: this.currentClient.email,
          restoName: this.getAllInfos.restoName,
          restoEmail: this.getAllInfos.restoMail,
          dateResa: `${this.currentResa.dateResa.labelDay} ${this.currentResa.dateResa.day.toString()} ${this.currentResa.dateResa.labelMonth} ${this.currentResa.dateResa.year.toString()}`,
          hourResa: hourFormatted,
          message: '',
          nbCouverts: this.currentResa.nbCouvert,
          adresse: this.getAllInfos.restoAdresse,
          tel: this.getAllInfos.restoTel,
          source: this.currentResa.source
        })
      }).catch((err) => {
        console.error('error on cancel resa', err)
      })
    },
    /**
     * Find reservation how going to be modified
     * TODO: migration for new reservation table
     */
    async findResa() {
      try {
        this.loading = true
        // get urls parameters
        let restoid = this.$router.currentRoute.params.id
        let idResa = this.$router.currentRoute.params.resa

        // get resa by id
        return await fetchGetHelper(ERequestType.RESAS.GET_BY_ID, `restoid=${restoid}&id=${idResa}`).then(resa => {
          if (resa && resa.data && resa.data.length > 0 && resa.data[0].state !== resaState.CANCELLED) {
            this.currentResa = resa.data[0]
            if (this.currentResa) {
              // check time if passed or not
              let today = new Date()
              let todayTs = today.getTime()
              let resaHour = parseTime(this.currentResa.hour)
              let dateResa = new Date(this.currentResa.dateResa.date)
              dateResa.setMinutes(resaHour.minutes)
              dateResa.setHours(resaHour.hours)
              if (todayTs > dateResa.getTime()) {
                return 'NOTHING'
              }
              // get couv
              this.currentNbCouv = this.currentResa.nbCouvert
              return this.checkClientByCidExisting({
                cid: this.currentResa.cid,
                restoid: this.$router.currentRoute.params.id
              }).then((res) => {
                if (res.data.cid !== undefined && res.data !== '') {
                  this.currentClient = res.data
                  return 'START'
                }
                return 'NOTHING'
              })
            }
            return 'NOTHING'
          } else {
            return 'NOTHING'
          }
        }).catch((err) => {
          console.error(err)
          return 'NOTHING'
        })
      } catch (err) {
        this.loading = true
        console.error('Error on find resa modification ', err)
        return 'NOTHING'
      }
    },
    /**
     * Launch modification action init form data
     */
    modifyResaCall: function () {
      this.step = 'MODIFY'
      // set data to form
      this.setSelectedDay(this.currentResa.dateResa)
      this.formModify.data.nbCouvert = this.currentResa.nbCouvert
      this.formModify.data.commentResa = this.currentResa.commentResa
    },
    /**
     * Valid modification
     */
    validModification: function (formName) {
      // TODO: create resa TO_CONFIRM
      this.loading = true

      let resaData = {
        id: uuidv4(),
        ts: dateToTimeStamp(this.getSelectedDay.day, this.getSelectedDay.month - 1, this.getSelectedDay.year),
        restoid: this.$router.currentRoute.params.id,
        cid: this.currentClient.cid,
        nbCouvert: this.formModify.data.nbCouvert,
        hour: this.formModify.data.date2.hour,
        dateResa: this.getSelectedDay,
        dateBooking: this.currentResa.dateBooking,
        room: '',
        tids: [],
        source: this.currentResa.source,
        ms: this.formModify.data.date2.ms,
        subs: this.formModify.data.date2.subs,
        commentResa: this.formModify.data.commentResa,
        state: resaState.TO_CONFIRM,
        preFix: this.currentResa.preFix,
        preFixServ: this.currentResa.preFixServ,
        type: this.currentResa.type,
        modifyBy: 'CLIENT'
      }
      if (this.currentResa.type === 'caution' || this.currentResa.type === 'prepaiement') {
        resaData.type = this.currentResa.type
        resaData.amount = this.currentResa.amount
        resaData.total = this.currentResa.total
        resaData.stripeid = this.currentResa.stripeid
        resaData.sid = this.currentResa.sid
        resaData.pid = this.currentResa.pid
        resaData.payementDone = this.currentResa.payementDone
      }
      fetchPostHelper(ERequestType.RESAS.CREATE, resaData).then((resaTaked) => {
        this.currentResa.modify = true
        fetchPostHelper(ERequestType.RESAS.DELETE, { restoid: this.currentResa.restoid, id: this.currentResa.id }).then((resaDeleted) => {
          this.loading = false
          this.step = 'MODIFY_DONE'
          let hourFormatted = formatTimeH(parseTime(resaTaked.data.hour))
          // send mail to client
          sendResaModifyMail({
            clientName: `${this.currentClient.name} ${this.currentClient.prenom}`,
            clientEmail: this.currentClient.email,
            restoName: this.getAllInfos.restoName,
            restoEmail: this.getAllInfos.restoMail,
            dateResa: `${resaTaked.data.dateResa.labelDay} ${resaTaked.data.dateResa.day.toString()} ${resaTaked.data.dateResa.labelMonth} ${resaTaked.data.dateResa.year.toString()}`,
            hourResa: hourFormatted,
            message: '',
            nbCouverts: resaTaked.data.nbCouvert,
            adresse: this.getAllInfos.restoAdresse,
            tel: this.getAllInfos.restoTel
          })
          // send mail to restaurateur
          sendResaModifyRestaurateur({
            clientName: `${this.currentClient.name} ${this.currentClient.prenom}`,
            clientEmail: this.currentClient.email,
            clientTel: this.currentClient.tel,
            restoName: this.getAllInfos.restoName,
            restoEmail: this.getAllInfos.restoMail,
            dateResa: `${resaTaked.data.dateResa.labelDay} ${resaTaked.data.dateResa.day.toString()} ${resaTaked.data.dateResa.labelMonth} ${resaTaked.data.dateResa.year.toString()}`,
            hourResa: hourFormatted,
            message: '',
            nbCouverts: resaTaked.data.nbCouvert,
            adresse: this.getAllInfos.restoAdresse,
            tel: this.getAllInfos.restoTel,
            source: resaTaked.data.source
          })
        })
      })
    }
  },
  // ------------------------------------------------------------------------------------ Created
  created: function () {
    // find resa
    this.findResa().then(res => {
      this.loading = false
      this.step = res
    })
    // remove version
    if (this.$parent.$refs.version !== undefined) this.$parent.$refs.version.remove()
  }
}
</script>

<style lang="scss">
@use "../styles/vars";
@use "../styles/mixins";

@use "../styles/components/elements/popup";
@use "../styles/components/elements/blackInputs";
@use "../styles/components/elements/buttons";
@use "../styles/components/elements/nav";
@use "../styles/components/elements/notif";
@use "../styles/components/elements/selector";
@use "../styles/components/layout/screens";
@use "../styles/components/layout/calendar";

a {
  color: var(--color_blue_azure);
}

.change {
  &-content {
    text-align: center;
    font-weight: 100;
    margin-top: 1rem;
  }

  &-container {
    padding-bottom: 1rem;
  }

  &-btns {
    margin-top: 2rem;
  }

  &-infos {
    margin-top: 1rem;
    font-weight: bold;
  }
}
</style>
